var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseSupportModalComponent } from "./base_support.component";
import { FormControl, Validators } from "@angular/forms";
var ChangeCurrencyModalComponent = /** @class */ (function (_super) {
    __extends(ChangeCurrencyModalComponent, _super);
    function ChangeCurrencyModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.oldCurrency = '';
        _this.newCurrency = '';
        return _this;
    }
    ChangeCurrencyModalComponent.prototype.ngOnInit = function () {
        var me = this;
        this.spreader.base.form = this.form;
        this.form.addControl('newCurrency', new FormControl('', [
            this.getStandartValidator('newCurrency_required', Validators.required, '"Новая валюта" - обязательное поле'),
            this.getCustomValidator('newCurrency_notOldCurrency', function (name, control) {
                var isInvalid = (control.value === me.oldCurrency);
                var err = {};
                err[name] = { value: control.value, message: "\"\u041D\u043E\u0432\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430\" - \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C '" + me.oldCurrency + "'" };
                return isInvalid ? err : null;
            })
        ]));
    };
    ChangeCurrencyModalComponent.prototype.ok = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm("\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0441\u043C\u0435\u043D\u0443 \u0432\u0430\u043B\u044E\u0442\u044B \u0434\u043B\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F " + this.title + "?")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.supportService.changeCurrency(this.userId, this.newCurrency, this.spreader.base.comment).toPromise()];
                    case 1:
                        _a.sent();
                        this.execute();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return ChangeCurrencyModalComponent;
}(BaseSupportModalComponent));
export { ChangeCurrencyModalComponent };
